'use client'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { setGuestStoreCookie } from '@/features/account/services/GuestUser/utils'
import { guestParamsQueryOptions } from '@/features/account/services/GuestUser/queryOptions'
import { type GuestStore } from '@/features/shop/services/ShoppingStore/types'
import { createPassiveQueryStore } from '@/features/shared/utils/dataFetching/createPassiveQueryStore'

export const useGuestParams = createPassiveQueryStore(() => guestParamsQueryOptions)

export const useSetGuestStoreCookie = () => {
  const queryClient = useQueryClient()

  return useCallback((store: GuestStore) => setGuestStoreCookie(store, queryClient), [queryClient])
}
